import type { Match } from '@uefadigital/panenka';
import i18n from 'i18next';
import { memo } from 'react';

import { translateEntity } from 'utils/translateEntity';

const ShowMatchDetails = ({ match }: { match: Match }) => {
  const competition = translateEntity(match.competition)?.name;
  const score = `${match.score?.total?.home} - ${match.score?.total?.away}`;
  const start = new Date(match?.kickOffTime?.dateTime ?? '');
  const date = start.toLocaleDateString(i18n.language, {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
  });
  const matchResult = `${translateEntity(match.homeTeam)?.displayName} ${score} ${
    translateEntity(match.awayTeam)?.displayName
  }`;

  const tournamentRound = `${competition} • ${translateEntity(match?.matchday)?.longName}`;
  const dateAndPlace = `${date} • ${translateEntity(match?.stadium)?.officialName}`;

  return (
    <div className="pk-text--center pk-font-size--s pr-py--6 pk-py--m pk-font--base-regular">
      <p className="pr-font-size--10 pk-text--elevation-01 pk-text--wrap">{dateAndPlace}</p>
      <p className="pr-font-size--10 pk-text--elevation-01 pk-text--wrap">{matchResult}</p>
      <p className="pr-font-size--10 pk-text--elevation-01 pk-text--wrap">{tournamentRound}</p>
    </div>
  );
};

export default memo(ShowMatchDetails);
